import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../../redux/reducers/spinner";
import { adminActions } from "../../../../redux/actions";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

const EVENTS = ["order.created", "order.updated", "pricing.changed"];

function CreateThirdPartyWebHook() {
  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const company_id = user?.data?.groups[teamId]?.company_id;
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [data, setData] = useState({ company_id: "", label: "", url: "" });
  const [eventsAllowed, setEventsAllowed] = useState([]);
  const { label, url } = data;
  const creating = useSelector((state) => state.admin.creating);

  const handleClose = () => setOpen(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEventChange = (event) => {
    const { value, checked } = event.target;
    setEventsAllowed((prev) =>
      checked ? [...prev, value] : prev.filter((e) => e !== value)
    );
  };
  
  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (label && url && company_id && eventsAllowed.length > 0) {
      dispatch(
        adminActions.createThirdPartyWebhooks(
          { ...data, company_id, events_allowed: eventsAllowed },
          setOpen
        )
      );
    }
  };

  return (
    <div>
      <MDBContainer>
        <MDBBtn color="primary" onClick={() => setOpen(true)}>
          Create Webhook
        </MDBBtn>
        <MDBModal isOpen={open} toggle={handleClose}>
          <form name="form" onSubmit={handleSubmit}>
            <MDBModalHeader toggle={handleClose}>
              Create Third Party Webhook
            </MDBModalHeader>
            <MDBModalBody>
              <div className="text-left row pt-4">
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && !label ? " has-error" : "")
                  }
                >
                  <label htmlFor="label">Label*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="label"
                    value={data.label}
                    onChange={handleChange}
                  />
                  {submitted && !label && (
                    <div className="help-block">Label is required</div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && !url ? " has-error" : "")
                  }
                >
                  <label htmlFor="url">URL*</label>
                  <input
                    type="url"
                    className="form-control"
                    name="url"
                    value={data.url}
                    onChange={handleChange}
                    placeholder="https://"
                  />
                  {submitted && !url && (
                    <div className="help-block">URL is required</div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && eventsAllowed.length === 0 ? " has-error" : "")
                  }
                >
                  <label>Events Allowed*</label>
                  {EVENTS.map((event) => (
                    <div className="form-check" key={event}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={event}
                        value={event}
                        checked={eventsAllowed.includes(event)}
                        onChange={handleEventChange}
                      />
                      <label className="form-check-label" htmlFor={event}>
                        {event}
                      </label>
                    </div>
                  ))}
                  {submitted && eventsAllowed.length === 0 && (
                    <div className="help-block">
                      At least one event is required
                    </div>
                  )}
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={handleClose}>
                Close
              </MDBBtn>
              <MDBBtn color="primary" type="submit">
                {creating === true ? (
                  <Beat loading={creating} />
                ) : (
                  "Create Third Party Token"
                )}
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default CreateThirdPartyWebHook;
